module.exports = __webpack_public_path__ + "media/images/play-4f38c1d3f3e32317ec4c6d80fdaf65a0.jpeg";